// extracted by mini-css-extract-plugin
module.exports = {"navItem":"NavItem_navItem__eslC_","navItemsList":"NavItem_navItemsList__W7_x6","active":"NavItem_active__YKsnl","rotate-180":"NavItem_rotate-180__bDxTz"};